// src/utils/pdfUtils.js
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

export async function makeAgreementPdf({ formData, signatureData, signatureIsUpload }) {
  // 1. Load the blank template
  const templateBytes = await fetch('/template.pdf').then(res => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(templateBytes);

  // 2. Embed a standard font
  const font = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);

  // 3. Grab the first page
  const page = pdfDoc.getPage(0);
  const { height } = page.getSize();

  // 4. Draw text fields (coordinates must match your template)
  page.drawText(formData.fullName, {
    x: 153,
    y: height - 173,
    size: 12,
    font,
    color: rgb(0, 0, 0),
  });

  page.drawText(formData.effectiveDate, {
    x: 321,
    y: height - 129,
    size: 12,
    font,
    color: rgb(0, 0, 0),
  });

  const rawAddress = formData.address || '';
  const singleLineAddress = rawAddress.replace(/[\r\n]+/g, ' ');
  page.drawText(singleLineAddress, {
    x: 72,
    y: height - 188,
    size: 12,
    font,
    color: rgb(0, 0, 0),
    maxWidth: 470,
    lineHeight: 15,
  });

  page.drawText(formData.email, {
    x: 130,
    y: height - 248,
    size: 12,
    font,
    color: rgb(0, 0, 0),
  });

  page.drawText(formData.phone, {
    x: 175,
    y: height - 276,
    size: 12,
    font,
    color: rgb(0, 0, 0),
  });
  
  const page6 = pdfDoc.getPage(5);
  
  // 5. Prepare the signature image (blacken if it's a drawn signature)
  let sigDataUrl = signatureData;
  if (!signatureIsUpload) {
    sigDataUrl = await toBlackPngDataUrl(signatureData);
  } else {
    // Convert uploaded signatures to PNG to ensure compatibility
    sigDataUrl = await convertToPng(signatureData);
  }

  // 6. Embed the signature PNG
  const sigImage = await pdfDoc.embedPng(sigDataUrl);

  // 7. Draw the signature at the bottom
  page6.drawImage(sigImage, {
    x: 300,
    y: 180,
    width: 160,
    height: 100,
  });

  // 8. Serialize to a Blob and return
  const pdfBytes = await pdfDoc.save();
  return new Blob([pdfBytes], { type: 'application/pdf' });
}

// Helper to convert any image format to PNG data URL
async function convertToPng(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = (err) => {
      reject(new Error('Failed to load signature image for conversion'));
    };
    img.src = dataUrl;
  });
}

// Helper to convert any PNG/data-URL into a pure-black version
async function toBlackPngDataUrl(dataUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = dataUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');

      // draw original
      ctx.drawImage(img, 0, 0);

      // pull pixel data
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imgData.data;

      // force any non-transparent pixel to black
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] > 0) {
          data[i] = 0;
          data[i + 1] = 0;
          data[i + 2] = 0;
        }
      }
      ctx.putImageData(imgData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
  });
}

